module.exports = __webpack_public_path__ + "ci_vendor_cloudinsight.60cc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_cloudinsight.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_cloudinsight.svg
// module chunks = main